import React from 'react';

const OtpTransferModalHelpPoints = ({ helpPoints }) => {
    return (
        <div className="otp-help-points">
            {helpPoints.map(helpPoint => {
                return (
                    <div key={helpPoint.id} className="otp-help-points-item">
                        <i className={`otp-help-points-icon icon--${helpPoint.icon}`} />
                        <div className="otp-help-points-item-title">{helpPoint.title}</div>

                        {helpPoint.text}
                    </div>
                );
            })}
        </div>
    );
};

export default OtpTransferModalHelpPoints;
